import React, { useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../loginSlice";
import "./login.css";
import { setBackButtonUrl } from "../uiSlice";
import Swal from "sweetalert2";

const TERMS_CONSENT_LABEL =
  "I have read and agree to the Terms & Conditions and consent to the use of my name, email address, and photo for the purposes described above.";

const escapeHtml = (str) =>
  String(str).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

function Login() {
  const dispatch = useDispatch();
  const { status, user, error } = useSelector((state) => state.auth);
  const { status: themeStatus, data: themeData } = useSelector(
    (state) => state.theme
  );

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isAdmin = searchParams.get("admin") === "true";

  useEffect(() => {
    dispatch(loginUser());
  }, [dispatch]);

  useEffect(() => {
    if (status === "succeeded" && user && isAdmin) {
      navigate("/admin");
    }
  }, [status, user, isAdmin, navigate]);

  useEffect(() => {
    console.log("user",user);
    if (status === "succeeded" && user.backButtonRedirect) {
      dispatch(setBackButtonUrl(user.backButtonRedirect));
    }

  }, [status, user]);

  useEffect(() => {
    const prevBodyOverflow = document.body.style.overflow;
    const prevHtmlOverflow = document.documentElement.style.overflow;
    const prevBodyOverscroll = document.body.style.overscrollBehavior;
    const prevHtmlOverscroll = document.documentElement.style.overscrollBehavior;

    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";
    document.body.style.overscrollBehavior = "none";
    document.documentElement.style.overscrollBehavior = "none";

    return () => {
      document.body.style.overflow = prevBodyOverflow;
      document.documentElement.style.overflow = prevHtmlOverflow;
      document.body.style.overscrollBehavior = prevBodyOverscroll;
      document.documentElement.style.overscrollBehavior = prevHtmlOverscroll;
    };
  }, []);



 useEffect(() => {
  if (status !== "failed") return;
  const msg = error ? String(error) : "Session expired";
  const redirect = user && user.backButtonRedirect ? user.backButtonRedirect : "/";
  Swal.fire("Session Expired!", msg, "error").then(() => {
    window.location.href = redirect;
  });
}, [status, error, user]);

  if (status === "loading" || themeStatus === "loading") {
    return (
      <div className="login-main-container">
        <div className="quiz-loader-container">
          <div className="quiz-loader"></div>
        </div>
      </div>
    );
  }

  const termsEnabled =
    themeData?.terms_enabled === true || themeData?.terms_enabled === "true";
  const termsText = (themeData?.terms_text || "").trim();

  // With terms on, Begin Play opens a blocking Terms popup first: Accept
  // continues to avatars, Decline returns to the game base page.
  const handleBeginClick = (e) => {
    if (!termsEnabled || !termsText) return;
    e.preventDefault();
    const baseUrl = (process.env.REACT_APP_BASE_URL || "").replace(/\/+$/, "");
    // Admin message is escaped (plain text only); the notice below it is static.
    const termsHtml =
      `<div class="terms-popup-message">${escapeHtml(termsText)}</div>` +
      `<div class="terms-popup-notice">Please review our ` +
      `<a href="${baseUrl}/terms" target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a> and ` +
      `<a href="${baseUrl}/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a> ` +
      `before proceeding. For information on withdrawing consent or requesting deletion of your data, contact ` +
      `<a href="mailto:contact@extramile.in">contact@extramile.in</a>.</div>`;
    Swal.fire({
      title: (themeData?.terms_heading || "").trim() || "Terms and Condition",
      html: termsHtml,
      input: "checkbox",
      inputValue: 0,
      inputPlaceholder: TERMS_CONSENT_LABEL,
      inputValidator: (value) =>
        value ? undefined : "Please tick the checkbox to accept the Terms & Conditions.",
      showCancelButton: true,
      confirmButtonText: "Accept",
      cancelButtonText: "Decline",
      reverseButtons: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      confirmButtonColor: "#16a34a",
      cancelButtonColor: "#dc2626",
      customClass: { popup: "terms-popup" },
      didOpen: (popupEl) => {
        popupEl.style.setProperty("--rules-text-color", themeData?.text_color || "#1a1a2e");
      },
    }).then((result) => {
      if (result.isConfirmed) {
        navigate("/avatar");
      } else {
        window.location.href = process.env.REACT_APP_BASE_URL;
      }
    });
  };

  const beginButtonStyle = {
    background: themeData?.button_background
      ? themeData.button_background
      : `linear-gradient(180deg, ${themeData?.button_color || '#fb9905'}, ${themeData?.button_color || '#f97316'})`,
    color: themeData?.button_text_color ? themeData.button_text_color : '#fff',
  };

  return (
    <div className="login-main-container">
      {themeData && themeData.logo && (
        <img
          src={process.env.REACT_APP_S3_PATH + themeData.logo}
          className="login-logo"
          alt="Game Logo"
        />
      )}
        {user && status === "succeeded" && (
          <div>
            {themeData?.beginButtonImage ? (
              <Link to="/avatar" onClick={handleBeginClick}>
                <img
                  src={process.env.REACT_APP_S3_PATH + themeData.beginButtonImage}
                  className="begin-play-btn-img"
                  alt="Begin Play"
                />
              </Link>
            ) : (
              <Link to="/avatar" className="begin-play-btn" style={beginButtonStyle} onClick={handleBeginClick}>
                Begin Play
              </Link>
            )}
          </div>
        )}
    </div>
  );
}

export default Login;
